import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vac-menu-options"
}
const _hoisted_2 = { class: "vac-menu-list" }
const _hoisted_3 = ["onClick"]

import { ref } from "vue";
import { CustomActions, CustomAction } from "vue-advanced-chat";
import { TicketModule } from "@/store/modules/Ticket";
import SvgIcon from "vue-advanced-chat/src/components/SvgIcon/SvgIcon.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    showSearch: { type: Boolean },
    menuActions: null,
    menuActionsHandler: null
  },
  setup(__props: any) {

const props = __props as {
	showSearch: boolean;
	menuActions: CustomActions;
	menuActionsHandler: (a: { roomId: string; action: CustomAction }) => void;
}



const menuOpened = ref(false);

function interactMenu() {
	menuOpened.value = !menuOpened.value;
}

function closeMenu(e: any) {
	if (e?.target?.id !== "svg-menu" && e?.target?.id !== "vac-icon-menu")
		menuOpened.value = false;
}

function actionHandler(e: any, action: CustomAction) {
	props.menuActionsHandler({
		roomId: TicketModule?.currentRoomID ?? "",
		action,
	});
	closeMenu(e);
}

function openSearchSidebar() {
	TicketModule.setOpenedSidebar(false);
	TicketModule.setOpenedSearchSidebar(!TicketModule.openedSearchSidebar);
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showSearch)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "vac-svg-button pr-1",
          onClick: openSearchSidebar
        }, [
          _createVNode(SvgIcon, {
            id: "svg-search",
            name: "search"
          })
        ]))
      : _createCommentVNode("", true),
    (__props.menuActions.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "vac-svg-button vac-room-options pl-1",
          onClick: interactMenu
        }, [
          _createVNode(SvgIcon, {
            id: "svg-menu",
            name: "menu"
          })
        ]))
      : _createCommentVNode("", true),
    (__props.menuActions.length)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 2,
          name: "vac-slide-left"
        }, {
          default: _withCtx(() => [
            (menuOpened.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuActions, (action) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: action.name
                      }, [
                        _createElementVNode("div", {
                          class: "vac-menu-item",
                          onClick: (e) => actionHandler(e, action)
                        }, _toDisplayString(action.title), 9, _hoisted_3)
                      ]))
                    }), 128))
                  ])
                ])), [
                  [_directive_click_outside, closeMenu]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})